import { buildPost } from 'api/builders';

export const start = buildPost({
  auth: 'api/stress/start',
});
